import React from 'react';
import { Link } from 'react-router-dom';
import { Youtube, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="dark-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3 className="footer-heading">PRAISE I AM APOLOGETICS</h3>
          <p className="footer-text">Defending Biblical Christianity — By Grace Alone</p>
        </div>

        <div className="footer-section">
          <h4 className="footer-subheading">Quick Links</h4>
          <div className="footer-links">
            <Link to="/apologetics" className="footer-link">Apologetics</Link>
            <Link to="/free-grace" className="footer-link">Free Grace</Link>
            <Link to="/debates" className="footer-link">Debates</Link>
            <Link to="/articles" className="footer-link">Articles</Link>
          </div>
        </div>

        <div className="footer-section">
          <h4 className="footer-subheading">Connect</h4>
          <div className="footer-social">
            <a href="https://www.youtube.com/@PRAISEIAMOFFICIAL" target="_blank" rel="noopener noreferrer" className="footer-social-link">
              <Youtube size={24} />
            </a>
            <a href="mailto:PraiseJesusThechrist@gmail.com" className="footer-social-link">
              <Mail size={24} />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-copyright">© 2025 Praise I AM Apologetics — Salvation by Grace Alone</p>
      </div>
    </footer>
  );
};

export default Footer;
